import utils from "../../../utils/utils.js";

export default {
    async fetchFeederBySourceId(context, payload) {
        const sourceIds = payload;

        let feeders = [];
        const query = new URLSearchParams();

        sourceIds.forEach(keyword => query.append("sourceIds", keyword));

        const response = await utils.utility.fetch(
            `api/Setting/GetPublishersByWorkspceSource?${query.toString()}`,
            "GET",
            null,
            null
        );

        const responseData = response.data;
        for (const index in responseData) {
            const feederItem = {
                id: responseData[index].id,
                text: responseData[index].name
            };

            feeders.push(feederItem);
        }
        context.commit("setFeeders", feeders);
    }
}